const TOKEN = 'CMG_ACCESS_TOKEN';

export { TOKEN };

export default {
  TOKEN,
};
